import React from 'react';
import { css } from '@emotion/react';
import { ScreenReaderOnly } from '@core/accessibility/screenReader/ScreenReaderOnly';
/**
 * Accessible icon component able to render either `img` or `svg` as a src.
 */
export const AccessibleIcon = ({ label, src, height, width }) => {
    const cssHeight = typeof height === 'string' ? height : `${height}px`;
    const cssWidth = typeof width === 'string' ? width : `${width}px`;
    return (<div className="accessible-icon" aria-hidden={label === ''} css={css `
        display: block;
        height: ${cssHeight};
        width: ${cssWidth};

        ${typeof src === 'string' &&
            css `
          background: transparent url(${src}) no-repeat center center;
          background-size: contain;
        `}
      `}>
      {typeof src !== 'string' && (<div css={css `
            display: flex;
            align-items: center;
            justify-content: center;
            height: ${cssHeight};
            width: ${cssWidth};
          `}>
          {src}
        </div>)}
      <ScreenReaderOnly>{label}</ScreenReaderOnly>
    </div>);
};
